export const FORM_SYS_NAME = 'fgt' as const;
export const PATIENT_360_NAME = 'cdr' as const;
export const DELIVERY_ROOM_NAME = 'sdrs' as const;
export const INIS_NAME = 'inis' as const;
